import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const TrackRevenues = () => {
  const getAll = params =>
    AuthAxios.get(`${DataApiUrl}/admin/trackRevenues`, { params })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const exportQuery = params =>
    AuthAxios.get(`${DataApiUrl}/admin/trackRevenues/exportQuery`, { params })
      .then(res => res.data)
      .catch(err => {
        throw err.response;
      });

  const attemptCreateRoyalties = () =>
    AuthAxios.post(`${DataApiUrl}/admin/trackRevenues/attemptCreateRoyalties`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  return {
    getAll,
    exportQuery,
    attemptCreateRoyalties,
  };
};

export default TrackRevenues;
